import tippy from 'tippy.js';
import * as tippyJs from 'tippy.js';
import Popper from './Popper.vue';

Popper.tippy = tippy;
Popper.tippyJs = tippyJs;

export default Popper;
